import {Record} from 'immutable';

export default class Behavior extends Record<{
    readonly id: string;
    readonly payload?: any;
}>({
    id: '',
    payload: null,
}) {}
